import { Transition }               from '@uirouter/core';

import { RequestPasswordResetComponent } from './password.request-reset.component';
import { ResetPasswordComponent }        from './password.reset.component';

export const PasswordsStates : Array<any> = [
  {
    component: RequestPasswordResetComponent,
    name     : 'app.reset-request',
    url      : '/reset_request'
  },
  {
    component: ResetPasswordComponent,
    name     : 'app.reset-password',
    resolve  : [
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().id,
        token    : 'id'
      },
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().resetToken,
        token    : 'resetToken'
      }
    ],
    url: '/reset/:id/:resetToken'
  }
];
